module.exports = __webpack_public_path__ + "static/media/official-doc-img-3.a67015cb.png";